/**
 * Makes the first character in a string uppercase
 */
export function capitalize(str: string): string {
  return str[0].toUpperCase() + str.substring(1);
}

/**
 * Waits at least for a set amout of milliseconds before resolving promise
 */
export async function thenWait<T>(ms: number, promise: Promise<T>): Promise<T> {
  const res = await Promise.all([ promise, wait(ms) ]);

  return res[0];
}

/**
 * Creates a promise that waits for a set amount of milliseconds
 */
export function wait(ms: number): Promise<void> {
  return new Promise(resolve => {
    setTimeout(() => resolve(), ms);
  });
}

/*
 * Runs callback when the document is fully loaded (may be now or later).
 * Just like jQuery.ready.
 */
export function documentReady(callback: () => void) {
  // @ts-ignore
  if (document.readyState != 'loading') {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', callback);
  }
}

export function findElementById<T extends Element = HTMLElement>(id: string | null): T | null {
  if (!id?.length) {
    return null;
  }

  return document.getElementById(id) as T|null;
}

export function distinct<T>(list: T[]): T[] {
  return list.filter((x, idx) => list.indexOf(x) == idx);
}
